import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CircleUploadFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 20.74C7.18 20.74 3.18 16.76 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18C16.82 3.18 20.82 7.16 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74ZM11.3 13.68H12.72V9.02L14.84 11.2L15.72 10.36L11.96 6.68L8.3 10.36L9.16 11.2L11.3 8.96V13.68ZM8.2 16.04H15.78V14.68H8.2V16.04Z" />
    </SvgIcon>
  );
});
